import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';

import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';
import Panel from '@cartwhl/ui/layout/Panel';

import { uiStore } from 'stores';

import PanelSearch from './PanelSearch';
import PoseGenerationHistory from './PoseGenerationHistory';

export default function PoseHistoryPanel({
  close,
  isOpen,
  enterTransitionDuration = 0,
  exitTransitionDuration = 0,
}: {
  close: () => void;
  isOpen?: boolean;
  enterTransitionDuration?: number;
  exitTransitionDuration?: number;
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchBarActive, setSearchBarActive] = useState(false);
  const [historyScope, setHistoryScope] = useState<'all' | 'renders'>('all');

  const { subPanelKey } = useSnapshot(uiStore.state);

  useEffect(() => {
    // TODO: Use a ref instead. Couln't get it to work with the complicated Input component...
    const input = document.getElementById('panel-search-input');
    if (!input) return;
    if (isSearchBarActive) {
      input.focus();
    } else {
      input.blur();
    }
  }, [isSearchBarActive]);

  return (
    <Panel
      title="History"
      closePanel={close}
      subPanelKey={subPanelKey}
      isOpen={isOpen}
      enterTransitionDuration={enterTransitionDuration}
      exitTransitionDuration={exitTransitionDuration}
      additionalButtons={
        <PanelSearch
          isSearchBarActive={isSearchBarActive}
          setSearchBarActive={setSearchBarActive}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      }
    >
      <div className="mb-2">
        <Text
          className="text-gray-60 dark:text-gray-45"
          variant="studio/body/sm"
        >
          Filter by
        </Text>
      </div>
      <div className="flex gap-2">
        <Button
          variant="secondary"
          onClick={() => setHistoryScope('all')}
          aria-pressed={historyScope === 'all'}
          data-state={historyScope === 'all' ? 'open' : undefined}
          className={`${historyScope === 'all' ? 'bg-gray-30 dark:bg-gray-60' : ''} flex-1`}
        >
          All history
        </Button>
        <Button
          variant="secondary"
          onClick={() => setHistoryScope('renders')}
          aria-pressed={historyScope === 'renders'}
          data-state={historyScope === 'renders' ? 'open' : undefined}
          className={`${historyScope === 'renders' ? 'bg-gray-30 dark:bg-gray-60' : ''} flex-1`}
        >
          Renders only
        </Button>
      </div>
      <div className={`mt-4`}>
        <PoseGenerationHistory
          historyScope={historyScope}
          searchTerm={searchTerm}
        />
      </div>
    </Panel>
  );
}
